import {
  START_LOADING,
  STOP_LOADING,
  START_VALIDATE_TAGS,
  ADD_TAG_ERROR,
  SET_LOCK_TAB_IR,
  SET_UNLOCK_TAB_IR,
  SET_LOCK_TAB_PO,
  SET_UNLOCK_TAB_PO,
  CLEAR_STATUS_TAB,
} from "./actionTypes";


export function startLoadingAction(){
  return function(dispatch){
    dispatch({
      type : START_LOADING
    })
  }
}

export function stopLoadingAction(){
  return function(dispatch){
    dispatch({
      type : STOP_LOADING
    })
  }
}

export function startValidateTagsAction() {
  return function (dispatch) {
    dispatch({
      type: START_VALIDATE_TAGS
    })
  }
}

export function addTagErrorAction(tag){
    return function (dispatch) {
        dispatch({
          type: ADD_TAG_ERROR,
          payload:tag
        })
      }
}

export function setStatusChangeIRAction(tag){
  return function (dispatch) {
      dispatch({
        type: SET_LOCK_TAB_IR,
        payload:tag
      })
    }
}

export function setStatusSaveIRAction(tag){
  return function (dispatch) {
      dispatch({
        type: SET_UNLOCK_TAB_IR,
        payload:tag
      })
    }
}

export function clearStatusTabAction(tag){
  return function (dispatch) {
      dispatch({
        type: CLEAR_STATUS_TAB,
        payload:tag
      })
    }
}

export function setStatusLockPOAction(tag){
  return function (dispatch) {
      dispatch({
        type: SET_LOCK_TAB_PO,
        payload:tag
      })
    }
}

export function setStatusUnlockPOAction(tag){
  return function (dispatch) {
      dispatch({
        type: SET_LOCK_TAB_PO,
        payload:tag
      })
    }
}